<template>
  <v-container style="height: 100%">
    <!--<v-layout row justify-center>-->
    <!--<v-flex md10>-->
    <v-card flat>
      <v-card-title class="title subprimary">
        <span>Научные специальности:</span>
        <v-spacer></v-spacer>
        <v-btn @click="opened_form = true" color="secondary" flat>
          <v-icon>add</v-icon>
          Добавить
        </v-btn>
        <v-btn @click="getItems()" color="primary" icon flat><v-icon>update</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-3 pt-1">
        <v-layout justify-center>
          <v-flex>
            <v-data-table

              :headers="headers"
              :items="items"
              :rows-per-page-items="[5,15,35,{text:'Все', value:-1}]"
              class="elevation-1  "
              hide-actions
              no-data-text="Нет данных"
              rows-per-page-text="Число элементов"
            >
              <template slot="items" slot-scope="props">
                <td class="justify-center">{{props.item.code }}</td>
                <td class="justify-center">
                  <div  v-for="item, i in props.item.name">
                    {{item.text}}
                  </div>

                </td>

                <td class="justify-center " v-bind="selected">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateItem(props.item)"
                        class="mr-2"
                        medium
                      >
                        edit
                      </v-icon>
                    </template>
                    <span>Редактировать</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="openConfirmDelete(props.item)"
                        medium
                      >
                        delete
                      </v-icon>
                    </template>
                    <span>Удалить</span>
                  </v-tooltip>
                </td>
              </template>
              <template slot="no-data">
                <v-btn @click="getItems()" color="primary">Обновить</v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog @input="closedForm" v-model="opened_form" width="500" persistent>
      <Scientific_specialty @addItem="addItem"
                @ended="closedForm"
                @refreshItem="refreshItem"
                v-bind="selected"
                v-if="opened_form"
      >
      </Scientific_specialty>
    </v-dialog>

    <v-dialog persistent v-model="opened_confirm" width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите удаление</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите удалить научную специальность?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
              @click="deleteItem(deletable.id)"
              color="warning"
              flat
            >
              Удалить
            </v-btn>
            <v-btn
              @click="closeConfirmDelete"
              flat
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--</v-flex>-->
    <!--</v-layout>-->
  </v-container>
</template>


<script>
    import Scientific_specialty from "../forms/Scientific_specialty"
    import urls from "../../../../../modules/petition/urls"
    import UserDataMixin from '../../../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "ListScientific_specialty",
        components: {Scientific_specialty},
        mixins: [UserDataMixin],

        data: function () {
            return {
                URL_LIST: urls.getUrl('admin|core|models|scientific_specialty-list', 'list'),
                URL_DELETE: urls.getUrl('admin|core|models|scientific_specialty-detail', 'destroy'),

                headers: [
                    {
                        text: 'Код',
                        align: 'justify-center',
                        sortable: false,
                        value: 'code',
                    },
                    {
                        text: 'Наименование', sortable: false, align: 'justify-center',
                        value: 'name',
                        // class: 'headline'
                    },
                    {
                        text: 'Действия', sortable: false, align: 'justify-center',
                        // class: 'headline'
                    }
                ],

            }
        },
        methods: {
        },
        created() {
            this.getItems();
            this.$store.commit('mainpage/changeTitle', 'Научная специальность');
        },
    }


</script>
<style scoped>

</style>
